import { useRefinementList } from 'react-instantsearch-hooks-web';

export const PathologyMapVirtualFilterPropertiesList = ({ attribute }) => {
  useRefinementList({
    attribute,
  });

  return null;
};
